import React from 'react'
import dynamic from 'next/dynamic'

import Experiment from '@mc/experiments-react'

import { ContinuousTrailersModalControl } from './ContinuousTrailersModalControl'
import { type ContinuousTrailersModalVariantProps } from '../types'
import { CONTINUOUS_TRAILERS_EXP_FLAG } from '../utils'

const ContinuousTrailersModalVariant1 = dynamic(
  () =>
    import(
      /* webpackChunkName: 'pen-4007_v1-variant_1' */ './ContinuousTrailersModalVariant1'
    ).then((mod) => mod.ContinuousTrailersModalVariant1),
  { ssr: false },
)

type ContinuousTrailerModalExperimentProps = {
  control: React.ReactNode
} & ContinuousTrailersModalVariantProps

export const ContinuousTrailerModalExperiment = ({
  control,
  ...videoModalProps
}: ContinuousTrailerModalExperimentProps) => (
  <Experiment
    name={CONTINUOUS_TRAILERS_EXP_FLAG}
    control={() => (
      <ContinuousTrailersModalControl
        control={control}
        courseSlug={videoModalProps.course?.slug || videoModalProps.courseSlug}
      />
    )}
    variant_1={() => <ContinuousTrailersModalVariant1 {...videoModalProps} />}
  />
)
